import * as tf from '@tensorflow/tfjs'
import { KNeighborsRegressor, setBackend } from '@/vendor/scikitjs/dist/es5'
import $ from "jquery";
import { generateUniqueId } from "@/assets/js/Utilities";

export default class AIExposure {
    constructor() {
        setBackend(tf)

        this.blockName = 'AIExposure';
        this.templateName = 'ai-exposure';
        this.category = 'AI Exposure';
        this.version = '1.0.0';

        this.img_size = 64
        this.lut_size = 8

        this.opacity = {
            minValue: 0,
            maxValue: 100,
        };
        this.model = {
            name: 'AI Exposure',
            file: null
        }
    }

    async addBlock(blockNum = lutify.blocks.length, data = false) {
        UI.createAdjustmentBlockTemplate(this.templateName, blockNum, data);
        let $element = $(UI.getAdjustmentBlock(blockNum));
        this.addRegenerateButton($element);

        UI.removeBlockBlendingModes($element);

        UI.appendBlockLoadingSpinner($element);
        lutPreviewer.showPlaceholderPreviews();

        await this.loadModel();

        $element.find(".lut-selector__items-container").hide();

        $element.on("click", e => {
            e.stopImmediatePropagation();

            lutify.selectedPreviewCategory = this.category;

            if (lutify.getActiveBlock().predictions.length > 0) {
                this.showAIPredictionPreviews();
                this.updateLutsDropdownList();
                this.enableLutDropdown();
                this.updateLabel()
            } else {
                UI.togglePreviewsContainer();
                lutPreviewer.showPlaceholderPreviews();
            }
        });

        // $element.find(".btn-remove-block").on("click", () => this.removeBlock());
        $element.find(".btn-reset-block").off("click").on("click", e => this.resetBlock($element, e));
        $element.find(".btn-reset-selection").on("click", e => this.removeSelection(e));

        $element.find(".lut-selector__label-container").on("click", e => this.toggleControlSelector($(e.currentTarget)));

        blocks.add({
            name: this.blockName,
            control: this.blockName,
            passes: this.addPasses(),
            predictions: [],
            predictionsContent: null,
            blockNum,
            blendingMode: 0,
            blendingModeName: "Normal",
            selectedPreview: null,
            selectedPreviewName: null,
            opacity: 100,
        });

        // coming from loading a preset/candidate
        if (!data?.waitToLoad) {
            $element.find(".expand_options").trigger("click", [false]);
            $element.trigger("click");
            await this.predict(this.model);
            UI.removeBlockLoadingSpinner($element);
        }

        UI.scrollToBlock(blockNum);
        UI.attachTemporaryLUTSelectionHandler();

        $element.find('.controls-wrapper .switch input').trigger('click')
    }

    toggleControlSelector($el) {
        let itemsContainer = $el.siblings(".lut-selector__items-container");
        if (itemsContainer.is(":visible")) itemsContainer.hide();
        else itemsContainer.show();
    }

    enableLutDropdown() {
        UI.getActiveBlock()
            .find(".lut-selector")
            .removeClass("--disabled");
        UI.getActiveBlock()
            .find(".block-sliders-container")
            .removeClass("--disabled");
    }

    disableLutDropdown() {
        UI.getActiveBlock()
            .find(".lut-selector")
            .addClass("--disabled");
        UI.getActiveBlock()
            .find(".block-sliders-container")
            .addClass("--disabled");
    }

    updateLabel() {
        if (lutify.getActiveBlock().selectedPreview !== null) {
            UI.getActiveBlock()
                .find(".selected-lut-name")
                .html("Look: " + lutify.getActiveBlock().selectedPreviewName);
        } else {
            UI.getActiveBlock()
                .find(".selected-lut-name")
                .html("Select...");
        }
    }

    updateLutsDropdownList() {
        let selectedLuts = [];

        let lutsList = UI.createLutDropdownList(lutify.getActiveBlock().predictions);
        UI.getActiveBlock()
            .find(".lut-selector__items-container")
            .html("");
        UI.getActiveBlock()
            .find(".lut-selector__items-container")
            .html(lutsList);
        UI.getActiveBlock()
            .find(".lut-selector__items-container > span")
            .on("click", e => this.lutDropdownSelection(e.currentTarget));
    }

    lutDropdownSelection(selectedLut) {
        let $blockOptions = $(selectedLut).closest(".block_options");
        $blockOptions.find(".lut-selector__items-container").hide();
        this.updateLabel();
        $(`#previews-list-container > .list-item[data-composer-index="${selectedLut.dataset.composerIndex}"]`).trigger("click");
    }

    async loadModel() {
        if (this.model.file) return
        if (vm.$store.state.UI[this.blockName].isDownloading) return;

        let storeData = await this.isModelDownloaded()

        if (!storeData) {
            vm.$store.dispatch(`UI/set${this.blockName}Downloading`, true);

            let response = await vm.$store.dispatch('Projects/fetchSystemFiles', {
                block: 'ai-magic-mode'
            })

            // AI Magic Mode system files returns more models
            response = response.splice(0, 3)

            let progress = []
            let promises = []


            response.forEach((file, idx) => {
                promises.push(
                    vm.$store.dispatch('Files/fetchFromS3', {
                        url: file.presignedURL,
                        config: {
                            responseType: 'blob',
                            onDownloadProgress: progressEvent => {
                                progress[idx] = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                            }
                        }
                    })
                )
            })

            let interval = setInterval(async () => {
                if (!progress.length) return
                let totalProgress = progress.reduce((r, i) => (r + i)) / promises.length

                if (totalProgress >= 100) clearInterval(interval)
            }, 50)

            let files = await Promise.all(promises)

            storeData = {
                model: new File([files[0]], response[0].name),
                weights: [
                    new File([files[1]], response[1].name),
                    new File([files[2]], response[2].name),
                ]
            }

            vm.$store.dispatch(`UI/set${this.blockName}Downloading`, false)
            await window.blocksStore.setItem(this.blockName, storeData)
        }

        this.model.file = await tf.loadLayersModel(
            tf.io.browserFiles([
                storeData.model,
                storeData.weights[0],
                storeData.weights[1]
            ])
        )
    }

    async isModelDownloaded() {
        let storeData = await window.blocksStore.getItem(this.blockName)
        return storeData
    }

    async predict(model) {
        const imageElement = await this.getImage(model);

        const {lutFile, lutContent} = await this.predictLutFromModel(model.file, imageElement);
        await this.createAIPredictedPreviews(lutFile, lutContent, model);
    }

    async createAIPredictedPreviews(lutFile, lutContent, model) {
        const targetPassIndex = 0;
        lutFile.control = this.blockName;
        lutFile.category = `${model.name}-${lutify.getActiveBlock().passes[targetPassIndex].uid}`;

        const loadedLutsList = [
            {
                ...lutFile,
                title: `${model.name} 1`,
                opacity: 25
            },
            {
                ...lutFile,
                title: `${model.name} 2`,
                opacity: 50
            },
            {
                ...lutFile,
                title: `${model.name} 3`,
                opacity: 75
            },
            {
                ...lutFile,
                title: `${model.name} 4`,
                opacity: 100
            },
        ];

        lutify.getActiveBlock().predictions = loadedLutsList;
        lutify.getActiveBlock().predictionsContent = lutContent;

        lutPreviewer.createPreviews(loadedLutsList, false, null, this.blockName);
    }

    async predictLutFromModel(model, imageElement) {
        let tensor = tf.browser.fromPixels(imageElement)

        tensor = tf.cast(tensor, 'float32')
        tensor = this.resize(tensor, this.img_size)
        let image = this.normalize(tensor)

        let image_reshaped = tf.reshape(image, [1, this.img_size, this.img_size, 3])
        let target = await model.apply(image_reshaped, {'training': true})
        let LUT = await this.img_to_lut(image, tf.squeeze(target))
        let [r, g, b] = this.split_channels(LUT, 3, 1)

        let text = `TITLE Created with fylm.ai ${this.blockName}\n`
        text = text + 'LUT_3D_SIZE 8\n\n'
        for (let i = 0; i < this.lut_size * this.lut_size * this.lut_size; i++) {
            text = text + r[i].toFixed(6).toString() + ' ' + g[i].toFixed(6).toString() + ' ' + b[i].toFixed(6).toString() + '\n'
        }

        let LUTFile = new File([text], `${this.templateName}.cube`, {type: 'text/plain'})
        let loadedLUTs = await luts.load([LUTFile])
        return {
            lutFile: loadedLUTs[0],
            lutContent: text
        }
    }

    async getImage(model) {
        let targetPassIndex = 0;
        let passes = blocks.getAllPassesToPass(lutify.getActiveBlock().passes[targetPassIndex].uid);

        // check the image size for when using larged media sizes
        let imageURL = lutify.getIDTLMTimage(passes) // getting the main canvas image with IDT LMT

        let imageElement = new Image()
        imageElement.src = imageURL
        await imageElement.decode()
        return imageElement
    }

    resize(input_image, size) {
        let output_image = tf.image.resizeNearestNeighbor(input_image, [size, size])
        return output_image
    }

    normalize(input_image) {
        let output_image = tf.sub(tf.div(input_image, 127.5), 1)
        return output_image
    }

    async img_to_lut(input_image, target_image) {
        let target = tf.add(tf.mul(target_image, 0.5), 0.5)
        let input = tf.add(tf.mul(input_image, 0.5), 0.5)

        let t = tf.sub(target, input)
        let [tR, tG, tB] = this.split_channels(t, 3, 2)

        let [iR, iG, iB] = this.split_channels(input, 3, 2)
        let icolor = tf.stack([iR, iG, iB]).transpose()

        let a = this.lut_size - 1
        let LUT = []
        for (let k = 0; k < this.lut_size; k++) {
            for (let j = 0; j < this.lut_size; j++) {
                for (let i = 0; i < this.lut_size; i++) {
                    LUT.push([i / a, j / a, k / a])
                }
            }
        }

        LUT = tf.stack(LUT)

        let interpolation = new KNeighborsRegressor(40, 'distance')
        await interpolation.fit(icolor, tR)
        let tRp = interpolation.predict(LUT)

        await interpolation.fit(icolor, tG)
        let tGp = interpolation.predict(LUT)

        await interpolation.fit(icolor, tB)
        let tBp = interpolation.predict(LUT)

        let [lutiR, lutiG, lutiB] = this.split_channels(LUT, 3, 1)
        lutiR = tf.add(lutiR, tRp)
        lutiG = tf.add(lutiG, tGp)
        lutiB = tf.add(lutiB, tBp)
        LUT = tf.stack([lutiR, lutiG, lutiB]).transpose()

        LUT = await tf.clipByValue(LUT, 0, 1)
        return LUT
    }

    split_channels(tensor, num_splits, axis) {
        let [tR, tG, tB] = tf.split(tensor, num_splits, axis)
        tR = tR.dataSync()
        tG = tG.dataSync()
        tB = tB.dataSync()
        return [tR, tG, tB]
    }

    addPasses() {
        const renderPass = gpu.createRenderPass();
        gpu.addPassToComposer(renderPass, "toMiddle");
        return [renderPass];
    }

    showPreviews(stepIndex) {
        vm.$store.dispatch('UI/setRegenerateAIBasedPreviewsButton', false);

        UI.togglePreviewsContainer();
        lutPreviewer.switchCanvases(this.controls[stepIndex].category);
        UI.updateSelectedPreview(lutify.getActiveBlock().selectedPreview[stepIndex]);

        lutPreviewer.cloneMainComposerPasses();
        lutPreviewer.addPass(this.controls[stepIndex].name, this.controls[stepIndex].category, stepIndex);
        lutPreviewer.render();
    }

    showAIPredictionPreviews(index = 0) {
        vm.$store.dispatch('UI/setRegenerateAIBasedPreviewsButton', true);

        const category = `${this.category}-${lutify.getActiveBlock().passes[index].uid}`;

        UI.togglePreviewsContainer();
        lutPreviewer.switchCanvases(category);
        UI.updateSelectedPreview(lutify.getActiveBlock().selectedPreview);

        lutPreviewer.cloneMainComposerPasses();

        this.addPassForAIPredictedPreview(lutify.getActiveBlock().predictions, index)
        vm.$nextTick(() => lutPreviewer.render());
    }

    addPassForAIPredictedPreview(luts, passIndexToSwap) {
        let passIdToSwap = lutify.getActiveBlock().passes[passIndexToSwap].uid;

        try {
            luts.forEach((lut, i) => {
                let composerIndex = lut.composerIndex;
                let pass = gpu.createLUTPass(lut.texture);
                pass.name = lut.title;
                pass.uid = passIdToSwap;

                if (lut.opacity) {
                    pass.uniforms.opacity.value = lut.opacity * 0.01;
                } else {
                    pass.uniforms.opacity.value = lutify.getActiveBlock().opacity * 0.01;
                }

                if (pass.uniforms.blendID) {
                    pass.uniforms.blendID.value = 0;
                }

                window.lutPreviewer.composers[composerIndex].passes.forEach((composerPass, j) => {
                    if (composerPass.uid == passIdToSwap) {
                        window.lutPreviewer.composers[composerIndex].removePass(composerPass);
                        window.lutPreviewer.composers[composerIndex].addPass(pass, j);
                    }
                });
            })
        } catch (error) {
            console.log(error);
        }
    }

    opacitySliderHandler(opacityValue) {
        let calcOpacityValue = opacityValue * 0.01;

        lutify.getActiveBlock().opacity = opacityValue;
        lutify.getActiveBlock().passes[0].uniforms.opacity.value = calcOpacityValue;
        lutify.getActiveBlock().passes[0].enabled = true;

        lutPreviewer.updateOpacity(calcOpacityValue, 0);
        UI.setPreviewerOpacity(lutify.getActiveBlock().opacity);

        gpu.render();
        lutPreviewer.render();
    }

    opacityInputHandler(opacityValue) {
        this.opacitySliderHandler(opacityValue)
    }

    resetBlock($element, e) {
        e.stopPropagation();
        $element.find(".opacity-input").val(100);
        $element.find(".opacity-input").trigger("change");

        UI.deselectPreview();
        UI.scrollToSelectedPreview();
        lutify.getActiveBlock().selectedPreview = null;
        lutify.getActiveBlock().selectedPreviewName = null;

        let renderPass = gpu.createRenderPass();
        renderPass.uid = lutify.getActiveBlock().passes[0].uid;
        lutify.getActiveBlock().passes[0] = renderPass;
        let targetPassIndex = gpu.getPassIndexById(lutify.getActiveBlock().passes[0].uid);
        gpu.composer.passes[targetPassIndex] = lutify.getActiveBlock().passes[0];

        gpu.render();

        this.updateLabel();
    }

    async regeneratePredictions() {
        lutify.getActiveBlock().passes[0].uid = generateUniqueId();

        this.disableLutDropdown();
        lutPreviewer.showPlaceholderPreviews();

        await this.predict(this.model);

        lutPreviewer.removePlaceholderPreviews();
        this.updateLutsDropdownList();
        this.enableLutDropdown();

        lutify.selectedPreviewCategory = this.category;
        this.showAIPredictionPreviews();

        $(`#previews-list-container .list-item[data-control="${this.blockName}"][data-category="${this.category}-${lutify.getActiveBlock().passes[0].uid}"][data-name="${lutify.getActiveBlock().selectedPreviewName}"]`).trigger("click");
    }

    addRegenerateButton($element) {
        let icon = document.createElement('i')
        icon.setAttribute('class', 'btn-block-regenerate material-icons')
        icon.setAttribute('data-tippy-content', 'Regenerate')
        icon.innerHTML = 'loop'
        icon.addEventListener('click', async () => {
            UI.appendBlockLoadingSpinner($element)

            this.regeneratePredictions()

            UI.removeBlockLoadingSpinner($element)
        })
        $element.find('.header-container .controls-wrapper').prepend(icon)
    }

    async applyCompare($block, data) {

        if (data.selectedPreviewName !== null) {
            if (data.predictionsContent) {
                let LUTFile = new File([data.predictionsContent], `${this.blockName}.cube`, {type: 'text/plain'})
                let loadedLUTs = await luts.load([LUTFile]);
                let passIndex = 0;

                await this.createAIPredictedPreviews(loadedLUTs[0], data.predictionsContent, this.model);

                lutPreviewer.cloneMainComposerPasses();
                this.addPassForAIPredictedPreview(lutify.getActiveBlock().predictions, passIndex)
                lutPreviewer.render();

                $(`#previews-list-container .list-item[data-control="${this.blockName}"][data-category="${this.category}-${lutify.getActiveBlock().passes[passIndex].uid}"][data-name="${data.selectedPreviewName}"]`).trigger("click");
            }
        }

        window.lutify.getActiveBlock().collapsedPreviews = data.collapsedPreviews;

        if (!lutify.getActiveBlock().predictions.length) {
            await this.predict(this.model);
        }

        this.updateLabel();
        UI.removeBlockLoadingSpinner($block);

    }

    removeSelection(e) {
        e.stopPropagation();
        lutify.getActiveBlock().selectedPreview = null;
        lutify.getActiveBlock().selectedPreviewName = null;
        lutify.getActiveBlock().passes[0].enabled = false;
        lutify.selectedPreviewCategory = this.category;
        gpu.render();

        this.showAIPredictionPreviews()

        this.updateLabel();
    }

    removeBlock() {
        //
    }

}
